import { ReactNode } from 'react';

/**
 * Opts its subtree out of session replay masking, which masks everything by default. Only the data
 * categories the privacy whitelist permits — record identifiers, job position, team — may be wrapped.
 * `contents` keeps the wrapper out of layout; nest `.ph-mask` to mask something inside it again.
 *
 * Wrapping block-level content needs `as="div"`, since a `span` may only hold phrasing content.
 */
const Unmasked = ({ children, as: Host = 'span' }: { children: ReactNode; as?: 'span' | 'div' }): JSX.Element => (
    <Host data-ph-unmask className="contents">
        {children}
    </Host>
);

export default Unmasked;
